(() => {
  function init(root = document) {
    root.querySelectorAll('.gft-shop').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      let timer;
      const summary = menu.querySelector('summary');
      const close = () => { menu.open = false; };
      menu.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse' && matchMedia('(min-width:1151px)').matches) { clearTimeout(timer); timer = setTimeout(() => { menu.open = true; }, 140); } });
      summary.addEventListener('click', () => clearTimeout(timer));
      menu.addEventListener('pointerleave', () => { clearTimeout(timer); timer = setTimeout(() => { if (!menu.contains(document.activeElement)) close(); }, 160); });
      menu.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); summary.focus(); e.stopPropagation(); } });
      menu.addEventListener('focusout', () => setTimeout(() => { if (!menu.contains(document.activeElement) && !menu.matches(':hover')) close(); }, 0));
      document.addEventListener('click', e => { if (!menu.contains(e.target)) close(); });
      document.querySelector('[data-ds-menue-auf]')?.addEventListener('click', close);
    });
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
